var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17778 9.18001C8.7611 9.59684 8.52706 10.1621 8.52717 10.7515C8.52727 11.3409 8.7615 11.9061 9.17834 12.3228C9.59517 12.7395 10.1605 12.9735 10.7498 12.9734C11.3392 12.9733 11.9044 12.7391 12.3211 12.3222M15.9511 15.9422C14.3925 16.9174 12.5885 17.4288 10.75 17.4167C6.75 17.4167 3.41667 15.1944 0.75 10.75C2.16333 8.39444 3.76333 6.66333 5.55 5.55667M8.72778 4.28333C9.39338 4.14859 10.0709 4.08158 10.75 4.08333C14.75 4.08333 18.0833 6.30556 20.75 10.75C20.01 11.9833 19.2178 13.0467 18.3744 13.9389M0.75 0.75L20.75 20.75",
    stroke: "#7C8796",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.5027820846b2efcef28cb53c09b2ba6e.svg";
export { ForwardRef as ReactComponent };